/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Injectable } from '@angular/core';
import { SettingsService } from '../interface/settings-service';

@Injectable()
export class DefaultSettingsService extends SettingsService {
  public isLoaded = false;
  constructor() {
    super();
  }

  public load() {
    if (!this.isLoaded) {
      const params = localStorage.getItem(this.getSettingsKey());
      if (params) {
        this.settings = JSON.parse(params);
      }
    }
    this.obs.next(this.settings);
  }
  public addSetting(name: string, value: any) {
    this.settings[name] = value;
    this.save();
  }

  public getSetting(name: string) {
    if (this.settings) {
      return this.settings[name];
    } else {
      return null;
    }
  }

  public save() {
    localStorage.setItem(this.getSettingsKey(), JSON.stringify(this.settings));
  }

  public clear() {
    localStorage.removeItem(this.getSettingsKey());
  }

  public reset() {
    this.isLoaded = false;
  }

  getSettingsKey(): string {
    return 'default-setting';
  }

  getAuthorization(crud: string[]): boolean {
    void crud;
    return true;
  }
}
